<li class='films__item' data-id={{id}}>
    <div class='films__img'>
        <img src='https://image.tmdb.org/t/p/w500{{poster_path}}' alt={{original_title}} loading='lazy' />
    </div>
    <div class='films__description'>
        <p class='films__name'>{{title}}</p>
        <div class="films__container">
            <p class='films__info'>{{genres}} | {{release_date}}</p>
            <span class='films__rating'>{{vote_average}}</span>
        </div>      
    </div>
</li>